module.exports = __webpack_public_path__ + "static/img/20221213_05.600a9ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221213_05.png
// module id = KoRn
// module chunks = 0